import { render, staticRenderFns } from "./NosologyForm.vue?vue&type=template&id=24892760"
import script from "./NosologyForm.vue?vue&type=script&lang=js"
export * from "./NosologyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports